export default __webpack_public_path__ + "static/media/eye.00d36aa8.svg";